import { DisconnectOutlined } from '@ant-design/icons'
import { Horizontal, BBDTag } from '@gravitate-js/excalibrr'
import { IconMapPinOff } from '@tabler/icons-react'
import { Tooltip } from 'antd'
import '../styles.css'
import { formatters } from '@/utils/intl/dateTimeFormatters'

type DriverFlagsProps = {
  hasNoGPS?: boolean
  isOffline?: boolean
  lastHeartbeat?: string | null
  timezone?: string
}

export function DriverFlags({ hasNoGPS, isOffline, lastHeartbeat, timezone }: DriverFlagsProps) {
  return (
    <Horizontal flex={1} justifyContent='right' gap={6}>
      {hasNoGPS && (
        <BBDTag className='driver-flag-tag px-2 py-1'>
          <IconMapPinOff size={14} className='mr-1' />
          No GPS
        </BBDTag>
      )}
      {isOffline && (
        <Tooltip
          title={
            lastHeartbeat ? `Last heartbeat ${formatters.TIME(lastHeartbeat, timezone)}` : 'Driver has not logged in'
          }
        >
          <BBDTag warning className='driver-flag-tag px-2 py-1'>
            <DisconnectOutlined className='driver-flag-icon mr-1' />
            Offline
          </BBDTag>
        </Tooltip>
      )}
    </Horizontal>
  )
}
